import { render, staticRenderFns } from "./OgcLayerResult.vue?vue&type=template&id=22cb809f&scoped=true"
import script from "./OgcLayerResult.vue?vue&type=script&lang=ts"
export * from "./OgcLayerResult.vue?vue&type=script&lang=ts"
import style0 from "./OgcLayerResult.vue?vue&type=style&index=0&id=22cb809f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb809f",
  null
  
)

export default component.exports